import $ from "cash-dom"
import throttle from "../util/throttle"
import debounce from "../util/debounce"

export default class BlockFadeModule {

    static name = 'blockfade'
    static pause = false

    constructor(node) {
        
        $(window).on('scroll', throttle(this.handleScroll, 300)) //at least every 300ms
        $(window).on('scroll', debounce(this.handleScroll, 300)) //for sure 300ms after scrolling ends
        
        this.handleScroll()

        //pause scrolling when another page is loading
        window.document.addEventListener('gamLinkLoading', () => {
            BlockFadeModule.pause = true

            //resume handleScroll when the upcoming gamMap is triggered ... 
            //(gamLinkLoaded is too early so we use gamMap)
            window.document.addEventListener('gamLinkLoaded', resume);
        })

        const resume = () => {
            window.document.removeEventListener('gamLinkLoaded', resume);
            BlockFadeModule.pause = false
            this.handleScroll()
        }
    }
    
    
    handleScroll = (e) => {
        if(BlockFadeModule.pause) return

        const $wraps = $('.wrap').not('.wrap--visible')
        const y = window.pageYOffset + (window.innerHeight*0.75)

        $wraps.each(function(i) {
            const $wrap = $(this)
            const top = $wrap.offset().top
            if(top < y) $wrap.addClass('wrap--visible')
        });
        
    }
}